export const actions = {
  AUTH_ERROR: 'AUTH_ERROR',
  RESET_AUTH_ERROR: 'RESET_AUTH_ERROR',
};
